import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
const DEFAULT_TLDS = ['com', 'org', 'net', 'ai', 'online', 'co'];
export const getTldSelectorData = async _ref => {
  let httpClient = _ref.httpClient,
    limit = _ref.request.limit;
  const _DomainsApiClient$que = DomainsApiClient.queries({
      httpClient
    }),
    listTldPromotions = _DomainsApiClient$que.listTldPromotions,
    domainsAccount = _DomainsApiClient$que.domainsAccount;
  try {
    const _await$Promise$allSet = await Promise.allSettled([listTldPromotions({
        limit
      }), domainsAccount({})]),
      listTldPromotionsResult = _await$Promise$allSet[0],
      domainsAccountResult = _await$Promise$allSet[1];
    const tldPromotions = (listTldPromotionsResult.status === 'fulfilled' ? listTldPromotionsResult.value.tldPromotions : null) ?? DEFAULT_TLDS.map(tld => ({
      tld
    }));
    const voucherSupportedTlds = domainsAccountResult.status === 'fulfilled' ? domainsAccountResult.value.voucherSupportedTlds : [];
    const hasValidVouchers = domainsAccountResult.status === 'fulfilled' ? Boolean(domainsAccountResult.value.hasValidVouchers) : false;
    const isPremiumSite = domainsAccountResult.status === 'fulfilled' ? Boolean(domainsAccountResult.value.isPremiumSite) : false;
    const tldSelectorData = tldPromotions.map(_ref2 => {
      let tld = _ref2.tld;
      return {
        tld: tld,
        isVoucherSupported: (voucherSupportedTlds == null ? void 0 : voucherSupportedTlds.includes(tld)) ?? false,
        hasValidVouchers,
        isPremiumSite
      };
    });
    if (!tldSelectorData.length) {
      return {
        tldSelectorData: DEFAULT_TLDS.map(tld => ({
          tld,
          isVoucherSupported: false,
          hasValidVouchers: false,
          isPremiumSite: false
        }))
      };
    }
    return {
      tldSelectorData
    };
  } catch (e) {
    return {
      tldSelectorData: DEFAULT_TLDS.map(tld => ({
        tld,
        isVoucherSupported: false,
        hasValidVouchers: false,
        isPremiumSite: false
      }))
    };
  }
};
//# sourceMappingURL=getTldSelectorData.js.map